export const formatInsuranceAmount = (amount: number): string => {
  if (!amount || amount === 0) return "0 ₽";

  return `${amount.toLocaleString("ru-RU")} ₽`;
};
